import PropTypes from "prop-types";

// store
import useBrainStore from "@/store/_brainEmStore";
import useLinkStore from "@/store/_linkStore";
import { organismImgData } from "@/data/OrganismImgData";

// components
import SectionHeading from "@/components/SectionHeading/SectionHeading";
import ImgBtn from "@/components/ImgBtn/ImgBtn";

// -----------------------------------------------------------------------------

// Get organism names (keys) from the data
// Calculate organism names once, outside the component
const organismNames = Object.keys(organismImgData);

// -----------------------------------------------------------------------------

export default function Organism({ isLinkMode }) {
	// Determine which store hook to use
	const useStore = isLinkMode ? useLinkStore : useBrainStore;
	// Select only the state and actions needed by this component
	const selectedOrganism = useStore((state) => state.organism);
	const setOrganism = useStore((state) => state.setOrganism);

	// -----------------------------------------------------------------------------

	return (
		<section>
			<SectionHeading heading="Organism" number={1} />

			<fieldset className="img-btn-group" aria-label="Organism">
				{/* Map over the pre-calculated organism names to create ImgBtn components */}
				{organismNames.map((organismName) => {
					const data = organismImgData[organismName]; // Get data for the current organism
					return (
						<ImgBtn
							key={organismName} // Use organismName as the key
							className={data.classNameSci} // Use data from organismImgData
							image={data.imageSci} // Use data from organismImgData
							alt={data.altSci} // Use data from organismImgData
							citation={data.citationSci} // Use data from organismImgData
							label={organismName} // Use the key as the label
							value={organismName} // Use the key as the value
							name="organism"
							checked={selectedOrganism === organismName}
							onChange={(e) => setOrganism(e.target.value)}
						/>
					);
				})}
			</fieldset>
		</section>
	);
}

// --------------------------------------------------------------

Organism.propTypes = {
	isLinkMode: PropTypes.bool.isRequired,
};
